import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { ErrorMessage } from '../../components';
import StackingCard from '../../components/CardStack/Card/StackingCard';
import CardStack from '../../components/CardStack/CardStack';
import { MerchantCard } from '../../components/MerchantCard/MerchantCard';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import BackButton from '../../lib/components/BackButton';
import { useIsMobile } from '../../utils/mediaQueries';
import styles from './styles';
export const MyLocations = () => {
    const { globalState: { merchantList, loading }, } = useGlobalStateContext();
    const [pageState] = useState('default');
    const { t: text } = useTranslation();
    const counterIncrease = 3;
    const [numCardsEnd, setNumCardsEnd] = useState(counterIncrease);
    const [numCardsStart, setNumCardsStart] = useState(0);
    const [list, setList] = useState([]);
    const [cards, setCards] = useState([]);
    useEffect(() => {
        setList(merchantList
            .sort((a, b) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return a.number - b.number;
        })
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .sort((a, b) => b.productOnboardingStatus - a.productOnboardingStatus));
        /*const l = globalState.merchantList
          .concat(globalState.merchantList)
          .concat(globalState.merchantList)
          .concat(globalState.merchantList)
          .concat(globalState.merchantList);
        setList(l);
    
        console.log('list', list);
        console.log('Merchant list', globalState.merchantList);*/
    }, [merchantList]);
    useEffect(() => {
        loadFunc();
    }, [list]);
    const loadFunc = async () => {
        //method to simulate partial load of the data
        try {
            // loading next 3 cards on scroll
            if (numCardsStart >= list.length)
                return;
            const arr = list.slice(numCardsStart, numCardsEnd);
            setCards([...cards, ...arr]);
        }
        catch (error) {
            console.error(error);
        }
        setNumCardsStart(numCardsStart + counterIncrease);
        setNumCardsEnd(numCardsEnd + counterIncrease);
    };
    const isMobile = useIsMobile();
    return (_jsx(Box, { children: _jsx(Grid, { container: true, direction: 'column', rowSpacing: 3, sx: styles.main, children: _jsxs(CardStack, { children: [_jsx(StackingCard, { lvl: 2, sectionName: text('MY_LOCATIONS_TITLE'), children: _jsx(Box, { sx: styles.cardHeader, children: _jsxs(Box, { sx: { flex: '1' }, children: [_jsx(BackButton, { sectionName: text('MY_LOCATIONS_TITLE') }), _jsx(Typography, { variant: 'h1', mt: 4, children: text('MY_LOCATIONS_TITLE') }), _jsx(Box, { sx: styles.bottom, children: _jsx(Box, { children: _jsx(Typography, { variant: 'subtitle1', sx: { fontSize: { mobile: '14px', desktop: '18px' } }, children: text('MY_LOCATIONS_SUBTITLE') }) }) })] }) }) }), _jsx(StackingCard, { color: '#E4EEEF', sectionName: text('MY_LOCATIONS_SUBTITLE2'), children: pageState === 'error' || (merchantList?.length === 0 && loading === false) ? (_jsx(Box, { sx: styles.errorContainer, children: _jsx(ErrorMessage, { message: text('ERROR_ON_PAGE'), type: 'Default' }) })) : (_jsxs("div", { style: { minHeight: '70vh' }, children: [_jsx(Box, { sx: styles.cardSubtitle, children: _jsx(Typography, { variant: 'h2', mt: 4, children: text('MY_LOCATIONS_SUBTITLE2') }) }), _jsx(Box, { sx: styles.merchantCardWrapper, children: _jsx(InfiniteScroll, { pageStart: 0, loadMore: loadFunc, hasMore: numCardsStart < list.length || loading, loader: _jsx(Box, { mt: 4, ml: 3, children: text('MY_LOCATIONS_LOADING') }, 0), children: _jsx("div", { style: styles.gridContainer(isMobile), children: cards.map((merchant) => (_jsx("div", { style: styles.cardContainer, children: _jsx(MerchantCard, { data: merchant }, merchant.number) }, merchant.number))) }) }) })] })) })] }) }) }));
};
